// All user related database operations can be defined here.
import { api } from '..';
import {
  CreateVehicleResponse,
  SetDefaultVehicleResponse,
  DeleteVehicleResponse,
  GetVehicleListResponse,
  GetVehicleIrregularitiesByVehicleResponse,
} from './types';

export * from './types';

export const fetchCreateVehicleService = async (params: {
  driverId: string;
  licensePlate: string;
  category: string;
  brand: string;
}) => {
  const { driverId, ...otherParams } = params;
  return await api
    .post<CreateVehicleResponse>(
      `drivers/${driverId}/vehicles`,
      JSON.stringify({ ...otherParams, driverId }),
    )
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return Promise.reject(err.response.data);
    });
};

export const fetchSetDefaultVehicleService = async (params: {
  driverId: string;
  vehicleId: string;
}) => {
  const { driverId, vehicleId } = params;
  return await api
    .put<SetDefaultVehicleResponse>(
      `drivers/${driverId}/vehicles/${vehicleId}/default`,
    )
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return Promise.reject(err.response.data);
    });
};

export const fetchDeleteVehicleService = async (params: {
  driverId: string;
  vehicleId: string;
}) => {
  const { driverId, vehicleId } = params;
  return await api
    .delete<DeleteVehicleResponse>(`drivers/${driverId}/vehicles/${vehicleId}`)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return Promise.reject(err.response.data);
    });
};

export const fetchGetVehicleListService = async (params: {
  driverId: string;
}) => {
  const { driverId } = params;
  return await api
    .get<GetVehicleListResponse>(`drivers/${driverId}/vehicles`)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return Promise.reject(err.response.data);
    });
};

export const fetchGetVehicleIrregularitiesByVehicleService = async (params: {
  driverId: string;
}): Promise<GetVehicleIrregularitiesByVehicleResponse> => {
  const { driverId } = params;
  return await api
    .get<GetVehicleIrregularitiesByVehicleResponse>(
      `notifications/driver/${driverId}/irregularities/vehicles`,
    )
    .then((res) => {
      const body = res.data;
      const rows = Array.isArray(body.data) ? body.data : [];
      return {
        response: body.response,
        data: rows.map(
          (row: {
            licensePlate?: string;
            plate?: string;
            irregularities: number;
          }) => ({
            licensePlate: row.licensePlate ?? row.plate ?? '',
            irregularities: row.irregularities,
          }),
        ),
      };
    })
    .catch((err) => {
      return Promise.reject(err.response.data);
    });
};
